import { AzureB2CConfig } from '@msc-b2c/interfaces/interfaces';
import { getCountryCode, getLanguageCode } from '@msc-b2c/shared-utils';

export const getLoginRedirectConfig = (
  azureConfig: AzureB2CConfig,
  actionType: string,
  fullLoginAuthenticationExchangePage = ''
) => {
  const baseConfig = {
    scopes: ['openid offline_access'],
    redirectUri: fullLoginAuthenticationExchangePage,
    extraQueryParameters: {
      ui_locales: `${getLanguageCode()}-${getCountryCode()?.toUpperCase()}`,
    },
  };

  const authorityMap = {
    login: azureConfig.loginUserFlow,
    signUp: azureConfig.signUpUserFlow,
    resetPassword: azureConfig.resetPasswordUserFlow,
  };

  return {
    ...baseConfig,
    authority: `${azureConfig.authorityBaseUrl}${
      authorityMap[actionType as keyof typeof authorityMap] || authorityMap.resetPassword
    }`,
  };
};
